import { SessionStorage, Events, Binding } from 'core/infrastructure';

import { DataGridColumn } from './DataGrid.Column';
import { ColumnFilter } from './DataGrid.Filter';
import { SortDirection } from './DataGrid.SortHeaderCell';

export interface SerializableState<T> {
	sortBy: Nullable<string>;
	sortDirection: Nullable<SortDirection>;
	searchText: string;
	selectedKeys: any[];
	scrollPosition: { x: number, y: number };
	columnWidths: { [columnKey: string]: number };
	columnFilter: ColumnFilter<T>[];
}

Events.on('session:logout', async () => {
	SessionStorage.getAllKeys()
		.filter(key => key.indexOf('__data-grid__state__') === 0)
		.forEach(SessionStorage.removeItem);
});

function getSessionKey(dataGridId: string) {
	return `__data-grid__state__${dataGridId}__${AGORA_VERSION}__`;
}

export function save<T>(dataGridId: string, state: SerializableState<T>) {
	SessionStorage.setItem(getSessionKey(dataGridId), JSON.stringify(state));
}

export function load<T>(dataGridId: string, currentColumns: DataGridColumn<T>[]): Nullable<SerializableState<T>> {
	const serialized = SessionStorage.getItem(getSessionKey(dataGridId));
	if (!serialized)
		return null;

	const state = JSON.parse(serialized) as SerializableState<T>;
	state.columnFilter = rebuildFilters(state.columnFilter, currentColumns);
	return state;
}

function rebuildFilters<T>(serializedFilters: ColumnFilter<T>[], columns: DataGridColumn<T>[]): ColumnFilter<T>[] {
	// Necesito reconstruir los filters eliminando los referidos a columnas que ya no existen y
	// volviendo a incluir la función de formato que no había sido serializada
	const filters: ColumnFilter<T>[] = [];
	serializedFilters.forEach(filter => {
		const column = columns.find(col => Binding.propertyPathToString(col.linkTo) === filter.propertyPath);
		if (column) {
			filters.push({
				...filter,
				format: column.format,
				// Convierto la fecha que estaba serializada a un objeto Date.
				// Uso el constructor (y no un parse) para que ajuste a hora local porque
				// al serializar a JSON se guarda como un string UTC
				argument: filter.dataType === 'date' && filter.argument ? new Date(filter.argument as string) : filter.argument
			});
		}
	});
	return filters;
}
